import React, { useEffect, useRef, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import Expander from '../Expander'
import Text from '../Text'
import ReservationInfo from '../ReservationInfo'
import { toggleWithLoadUpdateReservationModal } from '../../../actions/bookingCalendar/reservationModal/toggleReservationModal'
import { getEventById } from '../../../reducers/bookingCalendar/selectors/events'

export default function(notification, size = 1) {
  const [ref, setRef] = useState(null as HTMLSpanElement)
  const dispatch = useDispatch()
  const expanderRef: any = useRef()
  const localEvent = useSelector(getEventById(notification.reservationId))
  const remoteEvent = useSelector(
    getEventById(
      notification.bookingReservationLocalId
        ? notification.bookingReservationLocalId
        : notification.iCalendarReservationId,
    ),
  )

  useEffect(() => {
    function onChildClick(e) {
      const id = e.srcElement.className.includes('blue')
        ? notification.bookingReservationLocalId
          ? notification.bookingReservationLocalId
          : notification.iCalendarReservationId
        : e.target.innerText
      if (
        !(e.srcElement.className.includes('blue')
          ? remoteEvent.isDeleted
          : localEvent.isDeleted)
      ) {
        /*        if (expanderRef && expanderRef.current) {
          expanderRef.current.expand()
        }*/
        dispatch(toggleWithLoadUpdateReservationModal(String(id), true))
      }
    }

    if (ref) {
      const arr = Array.from(ref.children).filter(child =>
        child.className.includes('bbn__box__number'),
      )
      arr.forEach(child => {
        if (
          (child.className.includes('green') &&
            localEvent &&
            !localEvent.isDeleted) ||
          (child.className.includes('blue') &&
            remoteEvent &&
            !remoteEvent.isDeleted)
        ) {
          child.setAttribute('style', 'cursor: pointer')
          child.addEventListener('click', onChildClick)
        }
      })
    }

    return () => {
      if (ref) {
        const arr = Array.from(ref.children).filter(child =>
          child.className.includes('bbn__box__number'),
        )
        arr.forEach(child => {
          child.setAttribute('style', 'cursor: unset')
          child.removeEventListener('click', onChildClick)
        })
      }
    }
  })

  return (
    <Expander size={size} ref={expanderRef} id={notification.id}>
      <Text size={size}>
        <span
          ref={setRef}
          dangerouslySetInnerHTML={{ __html: notification.subtitle }}
        />
      </Text>
      <ReservationInfo size={size} reservation={notification} />
    </Expander>
  )
}
